import React from "react";
import { useUser } from "../../contexts/UserContext";
import { WelcomeHero } from "./components/WelcomeHero";
import { FinancialSnapshot } from "./components/FinancialSnapshot";
import { SmartInsights } from "./components/SmartInsights";
import { FamilyActivity } from "./components/FamilyActivity";
import { SpendingAnalytics } from "./components/SpendingAnalytics";
import ChatComponent from "./components/ChatComponent";

export const Dashboard: React.FC = () => {
  const { currentUser } = useUser();

  return (
    <div className="space-y-6 p-6">
      {/* Personalized Welcome with Financial Overview */}
      <WelcomeHero
        userName={currentUser?.displayName}
        timeOfDay={getTimeOfDay()}
      />

      {/* Key Financial Metrics */}
      <FinancialSnapshot />

      {/* AI-Powered Financial Intelligence */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SmartInsights />
        <SpendingAnalytics />
      </div>

      {/* Family Financial Activity */}
      <FamilyActivity />

      <ChatComponent />
    </div>
  );
};

const getTimeOfDay = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "morning";
  if (hour < 17) return "afternoon";
  return "evening";
};
